Monitoring.Views ||= {}

class Monitoring.Views.ImageUploadView extends Backbone.View
  template: JST['backbone/templates/image_attachment']

  initialize: (el, response) ->
    @images = []
    @$el = el
    @response = response
    @files = []

  render: ->
    @$el.html(@template)
    _uploadFile = (input) => @_uploadFile(input)
    callback = () -> _uploadFile @
    @$el.find('#file-image-upload-input').on('change', callback)

  allFiles: ->
    @files

  _uploadFile:(input) ->
    file = input.files[0]
    return unless file
    @files.push(file)
    extension = file.name.substr(file.name.lastIndexOf("."))
    if [".jpg", ".jpeg", ".png"].indexOf(extension) == -1
      @_resetImageUploader()
      $('#image-preview-container').hide()
      swal({
        title: 'You must upload an image',
        text: 'jpg, jpeg and png types are allowed. No image selected.'
        type: 'error'
      })
    @_readURL(input)

  _readURL:(input) ->
    if input.files and input.files[0]
      reader = new FileReader
      reader.onload = @addFile
      reader.readAsDataURL input.files[0]

  addFile:(event) =>
    image = event.target.result
    @addImage(image)

  addExternalImage: (image_url) =>
    @files.push(image_url)
    @addImage(image_url)

  addImage: (image) =>
    @images.push(image)
    label = new Monitoring.Views.ImageAttachmentLabelView(context: @, image: image)
    @response.addLabel(label)
    @_checkForHideBtn()

  resetFile:(image)->
    index = @images.indexOf(image)
    @images.splice(index, 1) if (index > -1)
    @files.splice(index, 1) if (index > -1)
    @_checkForHideBtn()

  _checkForHideBtn: ->
    if @files.length >= @_maxUploads()
      @$el.find("#add-image-btn").addClass("hidden")#.css("display", "none")#hide()
    else
      @$el.find("#add-image-btn").removeClass("hidden")#.css("display", "inline-block")#.show()

  toJSON: ->
    _.collect @files, (file)-> file.toJSON()

  _maxUploads: ->
    1

  _resetImageUploader: ->
    fileInput = @$el.find('#file-image-upload-input')
    fileInput.replaceWith(fileInput.val('').clone(true));